import {
  COOKIE_EXPIRY_AUTH,
  COOKIE_EXPIRY_CHAT_STARTED_FROM_GREETING,
  COOKIE_EXPIRY_NRMA,
  COOKIE_EXPIRY_RECENTLY_VIEWED,
  COOKIE_EXPIRY_TRACKING,
} from '@/constants/cookie.constants';

const getCookieExpiry = (expiryInMs: number) => new Date(new Date().getTime() + expiryInMs);

export const getCookieExpiryTracking = () => getCookieExpiry(COOKIE_EXPIRY_TRACKING);
export const getCookieExpiryAuth = () => getCookieExpiry(COOKIE_EXPIRY_AUTH);
export const getCookieExpiryRecentlyViewed = () => getCookieExpiry(COOKIE_EXPIRY_RECENTLY_VIEWED);
export const getCookieExpiryChatStartedFromGreeting = () => getCookieExpiry(COOKIE_EXPIRY_CHAT_STARTED_FROM_GREETING);
export const getCookieExpiryNrma = () => getCookieExpiry(COOKIE_EXPIRY_NRMA);
